import React from 'react';
import PropTypes from 'prop-types';

import './AppPageContentWrapper.scss';

export function AppPageContentWrapper({ bgColor, isDefaultPadding = true, children }) {
  return (
    <section className={bgColor}>
      <div className="container-md w-100">
        <div className="row px-3 px-md-0">
          <div className="col-12 col-md-8 offset-md-2">
            <div className={`${isDefaultPadding && 'pt-40 pb-80'}`}>{children}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

AppPageContentWrapper.propTypes = {
  children: PropTypes.node.isRequired
};

export default AppPageContentWrapper;
